import { render, staticRenderFns } from "./Animations.vue?vue&type=template&id=28504b9e&scoped=true&"
import script from "./Animations.vue?vue&type=script&lang=js&"
export * from "./Animations.vue?vue&type=script&lang=js&"
import style0 from "./Animations.vue?vue&type=style&index=0&id=28504b9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28504b9e",
  null
  
)

export default component.exports